import { Controller } from "stimulus";
import Rails from "@rails/ujs";

export default class extends Controller {
  static targets = [
    "mapsField",
    "streetField",
    "npaField",
    "localityField",
    "placeIdField",
  ];
  //static values = { id: Number }

  connect() {
    console.log("connect");
    this.initMap();
  }

  initialize() {
    console.log("initialize");
    //this.initMap();
  }

  test() {
    console.log("HEY PLACES");
  }

  initMap() {
    console.log("initMap");
    if (
      typeof google != "undefined" &&
      typeof google.maps != "undefined" &&
      typeof this.autocomplete == "undefined"
    ) {
      console.log("Google maps loaded");
      console.log(google);
      const center = { lat: 46.7667892, lng: 6.648535 };
      const defaultBounds = {
        north: center.lat + 1,
        south: center.lat - 1,
        east: center.lng + 1,
        west: center.lng - 1,
      };
      const options = {
        bounds: defaultBounds,
        componentRestrictions: { country: "ch" },
      };
      this.autocomplete = new google.maps.places.Autocomplete(
        this.mapsFieldTarget,
        options
      );
      this.autocomplete.setFields([
        "address_components",
        "place_id",
        "geometry",
        "icon",
        "name",
      ]);
      this.autocomplete.addListener(
        "place_changed",
        this.placeChanged.bind(this)
      );
    }
  }

  placeChanged() {
    let place = this.autocomplete.getPlace();
    let address = place.address_components;

    console.log("place", place);

    if (place) {
      this.streetFieldTarget.value = address.find((e) =>
        e.types.includes("route")
      ).long_name;
      let number = " ";

      if (address.find((e) => e.types.includes("street_number")).long_name) {
        number += address.find((e) => e.types.includes("street_number"))
          .long_name;

        this.streetFieldTarget.value += number;
      }

      this.npaFieldTarget.value = address.find((e) =>
        e.types.includes("postal_code")
      ).short_name;

      this.localityFieldTarget.value = address.find((e) =>
        e.types.includes("locality")
      ).long_name;

      this.placeIdFieldTarget.value = place.place_id;
    }
  }

  keydown(event) {
    if (event.key == "Enter") {
      event.preventDefault();
    }
  }
}
